import React from "react";
import { Heart } from "lucide-react";
import { motion } from "framer-motion";
import { LibraryItem } from "../../types/library";

interface ContentGridProps {
  items: LibraryItem[];
  onContentClick: (item: LibraryItem) => void;
}

const ContentGrid: React.FC<ContentGridProps> = ({
  items,
  onContentClick,
}) => {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-1 sm:gap-4">
      {items.map((item) => (
        <motion.div
          key={item.id}
          className="relative group rounded-lg overflow-hidden cursor-pointer"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
          onClick={() => onContentClick(item)}
        >
          <img
            src={item.thumbnailUrl}
            alt="Content"
            className="w-full h-auto object-cover aspect-square"
          />
          {item.isLiked && (
            <div className="absolute top-2 right-2 bg-red-500 p-1 rounded-full">
              <Heart size={16} className="text-white" />
            </div>
          )}
        </motion.div>
      ))}
    </div>
  );
};

export default ContentGrid;
